import { useMemo, useState } from 'react';
import { Header } from 'pages/HomePublic/components/Header';
import { useRule } from 'hooks/useRule';

export function Regulamento() {
  const rule = useRule();
  const [frameError, setFrameError] = useState(false);

  const regulationUrl = useMemo(() => rule?.regulation?.url || '', [rule]);
  const showIframe = Boolean(regulationUrl) && !frameError;

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentPage="regulamento" />

      <main className="px-4 py-8 pb-12">
        <div className="max-w-[1200px] mx-auto">
          <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8">
            <h1 className="text-3xl md:text-4xl font-bold text-blue-bb-6 leading-tight m-0">
              Regulamento
            </h1>

            <p className="text-base text-gray-600 mt-4 mb-6">
              Consulte o regulamento oficial do Prêmio BB. Caso a visualização incorporada não carregue,
              use o botão para abrir em nova aba.
            </p>

            {showIframe && (
              <div className="w-full h-[70vh] min-h-[520px] rounded-lg border border-gray-200 overflow-hidden bg-white">
                <iframe
                  src={regulationUrl}
                  title="Regulamento do Prêmio BB"
                  className="w-full h-full"
                  onError={() => setFrameError(true)}
                />
              </div>
            )}

            {!showIframe && (
              <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-6 text-gray-700">
                <p className="m-0">
                  Não foi possível exibir o regulamento incorporado no momento.
                </p>
              </div>
            )}

            <div className="mt-6">
              {regulationUrl ? (
                <a
                  href={regulationUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-lg bg-yellow-bb px-6 py-3 text-sm font-extrabold text-blue-bb hover:opacity-90 transition-opacity"
                >
                  ABRIR REGULAMENTO
                </a>
              ) : (
                <span className="text-sm text-gray-500">
                  O link do regulamento ainda não está disponível.
                </span>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
